import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const VibeModeContext = createContext({ active: false, enter: () => {}, exit: () => {} });

export function VibeModeProvider({ children, enabled = true }) {
  const [active, setActive] = useState(false);
  const enter = useCallback(() => { if (enabled) setActive(true); }, [enabled]);
  const exit = useCallback(() => setActive(false), []);
  const value = useMemo(() => ({ active: enabled && active, enabled, enter, exit }), [active, enabled, enter, exit]);
  return <VibeModeContext.Provider value={value}>{children}</VibeModeContext.Provider>;
}

export function useVibeMode() {
  return useContext(VibeModeContext);
}
